import { render, staticRenderFns } from "./TeamRegionSidebar.vue?vue&type=template&id=77f8f52c&scoped=true&"
import script from "./TeamRegionSidebar.vue?vue&type=script&lang=js&"
export * from "./TeamRegionSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TeamRegionSidebar.vue?vue&type=style&index=0&id=77f8f52c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f8f52c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77f8f52c')) {
      api.createRecord('77f8f52c', component.options)
    } else {
      api.reload('77f8f52c', component.options)
    }
    module.hot.accept("./TeamRegionSidebar.vue?vue&type=template&id=77f8f52c&scoped=true&", function () {
      api.rerender('77f8f52c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamRegions/TeamRegionSidebar.vue"
export default component.exports